import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Form, Header, Segment, Input, Checkbox } from 'semantic-ui-react';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const registration = [
    {
        key: 1,
        value: 1,
        text: 'Određeni broj dana prije svakog ispita'
    },
    {
        key: 2,
        value: 2,
        text: 'Određeni datum za sve ispite'
    }
];

export default class NewExamTerm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            endDate: null,
            startDate: new Date(),
            openDate: null,
            comment: '',
            registrationOpening: '',
            registrationClosing: '',
            registrationType: '',
            oneExamRestriction: false,
            gradStudentExamRestriction: false,
            gradAgainStudentExamRestriction: false,


            nameErr: false,
            sDateErr: false,
            eDateErr: false,
            openErr: false,
            openDateErr: false,
            closeErr: false,
            registrationTypeErr: false,
            loadingButton: false
        };

        this.addExamTerm = this.addExamTerm.bind(this);
        this.closeAddMode = this.closeAddMode.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });

        if (name === 'endDate' && date < this.state.startDate && this.state.startDate) {
            this.setState({ [name]: null });
            toast('Datum kraja mora biti poslije datuma početka!');
        }
        if (name === 'startDate' && date > this.state.endDate && this.state.endDate) {
            this.setState({ [name]: null });
            toast('Datum početka mora biti prije datuma kraja!');
        }
        if (name === 'openDate' && date > this.state.startDate) {
            this.setState({ [name]: null });
            toast('Datum početka prijave ispita mora biti prije početka ispitnog roka!');
        }
    }


    addExamTerm(name, sDate, eDate, comment, registrationClosing, registrationType, oneExamRestriction, gradStudentExamRestriction, gradAgainStudentExamRestriction) {
        const { openDate, registrationOpening } = this.state;

        if (registrationOpening && registrationClosing && parseInt(registrationOpening, 10) < parseInt(registrationClosing, 10)) {
            toast('Broj dana prije ispita od kada počinje prijava ispita mora biti veći od broja dana prije ispita do kada traje prijava ispita.');
            return;
        }


        this.setState({ loadingButton: true });
        if (!name || !sDate || !eDate || !registrationClosing || !registrationType || (registrationType === 1 && !this.state.registrationOpening)
            || (registrationType === 2 && !this.state.openDate)) {
            toast('Niste unijeli sva obavezna polja!');
            if (!name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
            if (!sDate) { this.setState({ sDateErr: true }); } else { this.setState({ sDateErr: false }); }
            if (!eDate) { this.setState({ eDateErr: true }); } else { this.setState({ eDateErr: false }); }
            if (!registrationType) { this.setState({ registrationTypeErr: true }); } else { this.setState({ registrationTypeErr: false }); }
            if (registrationType === 1 && !registrationOpening) { this.setState({ openErr: true }); } else { this.setState({ openErr: false }); }
            if (registrationType === 2 && !openDate) { this.setState({ openDateErr: true }); } else { this.setState({ openDateErr: false }); }
            if (!registrationClosing) { this.setState({ closeErr: true }); } else { this.setState({ closeErr: false }); }
            this.setState({ loadingButton: false });
        } else {
            let newTerm = { oneExamRestriction: !!oneExamRestriction };
            if (gradAgainStudentExamRestriction) newTerm = { ...newTerm, gradAgainStudentExamRestriction: !!gradAgainStudentExamRestriction };
            if (gradStudentExamRestriction) newTerm = { ...newTerm, gradStudentExamRestriction: !!gradStudentExamRestriction };
            if (name) newTerm = { ...newTerm, name };
            if (sDate) {
                let startDate = moment(sDate).format();
                newTerm = { ...newTerm, startDate };
            }
            if (eDate) {
                let endDate = moment(eDate).format();
                newTerm = { ...newTerm, endDate };
            }

            if (openDate) {
                let openDate_ = moment(openDate).format();
                newTerm = { ...newTerm, registrationOpeningDate: openDate_ };
            }
            if (comment) newTerm = { ...newTerm, comment };
            if (registrationOpening) newTerm = { ...newTerm, registrationOpeningDays: registrationOpening };
            if (registrationClosing) newTerm = { ...newTerm, registrationClosing };

            axios.post('exams/create-term', { ...newTerm })
                .then(res => {
                    toast('Uspješno ste kreirali ispitni rok.');
                    this.props.addExamTerm();
                    this.setState({ loadingButton: false });
                })
                .catch(err => {
                    toast('Došlo je do greške! Kreiranje ispitnog roka nije uspjelo.');
                    this.props.addExamTerm();
                    this.setState({ loadingButton: false });
                });
        }
    }

    closeAddMode() {
        this.props.closeAddMode();
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value, openDate: null, registrationOpening: ''
        });
    }

    render() {
        if (this.state.error) return <div>Greška</div>;
        return (
            <div>
                <Segment.Group secondary>
                    <Segment secondary clearing>
                        <Form noValidate>
                            <Form.Group >
                                <Form.Field
                                    width={8}
                                    required
                                    control={Input}
                                    label="Naziv ispitnog roka"
                                    value={this.state.name}
                                    onChange={(e) => this.setState({ name: e.target.value })}
                                    name="name"
                                    placeholder="Unesite naziv ispitnog roka"
                                    error={this.state.nameErr}
                                />

                                <Form.Field required error={this.state.sDateErr} width={4}>
                                    <label>Datum početka ispitnog roka</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        defaultValue={new Date()}
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'startDate')}
                                        value={this.state.startDate}
                                    />
                                </Form.Field>
                                <Form.Field required error={this.state.eDateErr} width={4}>
                                    <label>Datum kraja ispitnog roka</label>
                                    <DateTimePicker
                                        format="D. M. YYYY."
                                        defaultValue={null}
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'endDate')}
                                        value={this.state.endDate}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group >
                                <Form.Field required width={8}>
                                    <label>Otvaranje prijave ispita</label>
                                    <Form.Dropdown
                                        clearable
                                        selection
                                        placeholder="Odaberite način otvaranja ispita za prijavu"
                                        value={this.state.registrationType}
                                        onChange={this.handleInputChange}
                                        name="registrationType"
                                        options={registration}
                                        search
                                        fluid
                                        error={this.state.registrationTypeErr}
                                    />
                                </Form.Field>
                                {this.state.registrationType === 1 ?
                                    <Form.Field
                                        width={4}
                                        type="number"
                                        disabled={!this.state.registrationType}
                                        required
                                        control={Input}
                                        label="Početak prijave ispita (broj dana prije ispita)"
                                        value={this.state.registrationOpening}
                                        onChange={(e) => this.setState({ registrationOpening: e.target.value })}
                                        name="registrationOpening"
                                        placeholder="Unesite broj dana"
                                        error={this.state.openErr}
                                    />
                                    : this.state.registrationType === 2 ? <Form.Field required error={this.state.openDateErr} disabled={!this.state.registrationType} width={4}>
                                        <label>Početak prijave ispita od datuma</label>
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            defaultValue={null}
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'openDate')}
                                            value={this.state.openDate}
                                        />
                                    </Form.Field>
                                        : <Form.Field
                                            width={4}
                                            type="number"
                                            disabled
                                            required
                                            control={Input}
                                            label="Početak prijave ispita"
                                        />}
                                <Form.Field
                                    type="number"
                                    required
                                    width={4}
                                    control={Input}
                                    label="Kraj prijave ispita (broj dana prije ispita)"
                                    value={this.state.registrationClosing}
                                    onChange={(e) => this.setState({ registrationClosing: e.target.value })}
                                    name="registrationClosing"
                                    placeholder="Unesite broj dana"
                                    error={this.state.closeErr}
                                />
                            </Form.Group>
                            <Form.Group >
                                <Form.Field width={16}>
                                    <label> Napomena</label>
                                    <Form.TextArea
                                        placeholder="Unesite napomenu"
                                        rows={1}
                                        value={this.state.comment}
                                        onChange={(e) => this.setState({ comment: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
<br/>
                            <Form.Field>
                                <Checkbox
                                    type="checkbox"
                                    name="oneExamRestriction"
                                    value={this.state.oneExamRestriction}
                                    onChange={() => { this.setState({ oneExamRestriction: !this.state.oneExamRestriction }); }}
                                    checked={this.state.oneExamRestriction}
                                    label="ograničenje na prijavu samo jednog ispita"
                                />
                            </Form.Field>
                            <br/>
                            <Form.Group>
                                <Form.Field>
                                    <label>Ograničenje da ispite na ovom roku mogu prijaviti samo:</label>
                                    <div style={{
                                        fontStyle: 'italic', fontSize: '13px', marginTop: '4px', color: '#666'
                                    }}
                                    >
                                        * Ukoliko ne označite ništa, ispite na ovom roku mogu prijaviti svi studenti.
                                    </div>
                                </Form.Field>

                                <Form.Field>
                                    <Checkbox
                                        type="checkbox"
                                        name="gradStudentExamRestriction"
                                        value={this.state.gradStudentExamRestriction}
                                        onChange={() => { this.setState({ gradStudentExamRestriction: !this.state.gradStudentExamRestriction }); }}
                                        checked={this.state.gradStudentExamRestriction}
                                        label="apsolventi"
                                    />
                                </Form.Field>

                                <Form.Field>
                                    <Checkbox
                                        type="checkbox"
                                        name="gradAgainStudentExamRestriction"
                                        value={this.state.gradAgainStudentExamRestriction}
                                        onChange={() => { this.setState({ gradAgainStudentExamRestriction: !this.state.gradAgainStudentExamRestriction }); }}
                                        checked={this.state.gradAgainStudentExamRestriction}
                                        label="apsolventi ponovci"
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Button disabled={this.state.loadingButton} color="blue" basic="true" floated="right" onClick={this.closeAddMode}>Odustani</Button>
                            <Button
                                disabled={this.state.loadingButton}
                                loading={this.state.loadingButton}
                                color="blue"
                                floated="right"
                                onClick={
                                    () => {
                                        this.addExamTerm(
                                            this.state.name,
                                            this.state.startDate,
                                            this.state.endDate,
                                            this.state.comment,
                                            this.state.registrationClosing,
                                            this.state.registrationType,
                                            this.state.oneExamRestriction,
                                            this.state.gradStudentExamRestriction,
                                            this.state.gradAgainStudentExamRestriction
                                        );
                                    }
                                }
                            >
                                Kreiraj
                            </Button>

                        </Form>
                    </Segment>
                    {/* <ToastContainer hideProgressBar /> */}
                </Segment.Group>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/NewExamTerm.js